import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import CustomFormLabel from "../../components/common/form-label/CustomFormLabel ";
import { triggerAppAlert } from "../../redux/actions/SelfServicePortal/ContactAid/ContactAid";
import CategoryTreeSelection from '../new-ticket/AddCategoryPopup';
import ClearIcon from "@mui/icons-material/Clear";

interface Category {
  id: number;
  name: string;
  label ?: string;
}
const CategorySelectField = ({ticketTypeId,isMandotary=false,initVal=null}:{ticketTypeId:number|null,isMandotary:boolean,initVal?:null | Category}) =>{
    const [categoryVal,setCategoryVal] = useState<null | Category>(initVal);
    const inputRef = useRef<HTMLInputElement>();
    const hiddenInputRef = useRef<HTMLInputElement>();
    const dispatch = useDispatch();
    const onCategorySubmit = (res: Category | null) => {
        paintValue(res);
    };
    useEffect(()=>{
        setTimeout(() => {
          paintValue(initVal);  
        }, 100);
    },[initVal]);
    const clearCategory = () => {
        paintValue(null);
    };
    useEffect(()=>{
        onCategorySubmit(null);
    },[ticketTypeId]);
    const openModal = ()=>{
        if(ticketTypeId){
            dispatch({
              type:"CATEGORY_POPUP_TICKET_TYPE_ID",
              payload : ticketTypeId
            })
          }else{
            dispatch(triggerAppAlert("Please choose Ticket type before selecting Category","warning"))
        }
    }

    const paintValue = (val: Category | null) => {
        if(inputRef?.current && hiddenInputRef?.current){
                inputRef.current.value = val?.label ||  "";
                hiddenInputRef.current.value = `${val?.id ||  ""}`;
                setCategoryVal(val);
        }
    }
    return (<>
        <Box className="common-category-field common-new-input-holder">
            <CustomFormLabel
                labelName={"Category"}
                isMandotary={false}
                classNames='app-field-label'
            />
            <TextField
                fullWidth
                inputProps={{
                    'data-id': categoryVal?.id || 0,
                    'data-label': categoryVal?.name || 0,
                    readOnly: true,
                }}
                placeholder="Please Enter"
                title={"Category"}
                inputRef={inputRef}
                name="categoryId-field"
                className={`common-new-input`}
                required={isMandotary}
                onClick={openModal}
                InputProps={{
                    endAdornment:  categoryVal && categoryVal?.id && (
                    <InputAdornment className="clear-btn" position="end">
                        <IconButton
                        aria-label="clear category"
                        onClick={(e) => {
                            e.stopPropagation(); 
                            clearCategory(); 
                        }}
                        edge="end"
                        >
                        <ClearIcon />
                        </IconButton>
                    </InputAdornment>
                    )
                }}
            />
            <Box className="d-none">
                <TextField
                    inputProps={{
                        'data-id': categoryVal?.id || 0,
                        'data-label': categoryVal?.name || 0,
                        readOnly: true,
                    }}
                    name="categoryId"
                    inputRef={hiddenInputRef}
                />
            </Box>
            
            <CategoryTreeSelection callback={onCategorySubmit}/> 
        </Box>
    </>)
}
export default CategorySelectField;